import ReqClient from './request.class'

// 腾讯广告ada计划提交
export async function submitTencentADAPlans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addGdtAdaBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function updateTencentADAPlans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateGdtAdaAdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据多个id获取素材详情
 * @param {*} params
 * @return {*}
 */
export async function queryImageDetailByIds(data) {
  const Req = new ReqClient({
    url: '/api/ptom/imageInfo/queryImageDetailByIds',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 腾讯广告v3批量新建计划
 * @param {*} data
 */
export async function submitTencentV3Plans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addGdtv3BatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 腾讯广告搜索广告批量新建、复制计划
 * @param {*} data
 */
export async function submitTencentSearchAdPlans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatchSousuo/addSousuoBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 腾讯广告搜索广告批量修改计划
 * @param {*} data
 */
export async function updateTencentSearchAdPlans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatchSousuo/updateSousuoAdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 腾讯广告v3已有计划下新增创意
 * @param {*} data
 */
export async function submitTencentV3AddCreatives(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addGdtv3CreativeTask',
    method: 'POST',
    data
  })

  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function updateTencentV3Plans(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateGdtv3AdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 从媒体获取腾讯广告v3计划详情
 * @param {*} params
 * @return {*}
 */
export async function getTencentV3AdInfo(params) {
  const Req = new ReqClient({
    url: '/api/media/project/getAdGroupInfoGdtv3',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 更新腾讯广告3.0单条计划修改
 * @param {*} data
 */
export async function updateTencentV3Plan(data) {
  const Req = new ReqClient({
    url: '/api/media/project/updateAdGroupGdtv3',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 从媒体获取腾讯广告v3创意详情
 * @param {*} params
 * @return {*}
 */
export async function getTencentV3CreativeInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/promotion/getCreativesInfoGdtv3',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 更新腾讯广告3.0单条计划创意修改
 * @param {*} data
 */
export async function updateTencentV3Creative(data) {
  const Req = new ReqClient({
    url: '/api/ptom/promotion/updateCreativeGdtv3',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
